var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLaptop = function SvgLaptop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M14.9224 14.5H1.07746C0.706 14.5089 0.357403 14.3213 0.160291 14.0064C-0.0368215 13.6915 -0.0532322 13.2961 0.117114 12.966L0.977421 11.266V3.50003C0.977415 2.96785 1.18958 2.45763 1.56695 2.08226C1.94432 1.7069 2.45579 1.49736 2.98814 1.50003H13.0217C14.1292 1.49781 15.0291 2.39292 15.0324 3.50003V11.267L15.8827 12.967C16.0532 13.297 16.0369 13.6924 15.8397 14.0072C15.6425 14.3219 15.2938 14.5093 14.9224 14.5ZM13.0017 3.50003H2.99814V9.50002H13.0017V3.50003ZM12.9017 11.5H3.10818L2.608 12.5H13.4019L12.9017 11.5Z"
  })));
};
export default SvgLaptop;